"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var directive_1 = require("./directive");

var plugin_1 = require("./plugin");

var version_1 = require("./version");

function default_1(target) {
  if ((0, version_1.hasVueApp)() && !(0, version_1.isVue3)()) {
    return target;
  }

  var install = target.install,
      directives = target.directives;

  if ((0, version_1.hasVueApp)() && directives) {
    // eslint-disable-next-line no-param-reassign
    target.directives = (0, directive_1.createDirectives)(directives, (0, version_1.getVueApp)());
  }

  if (typeof install === 'function') {
    // eslint-disable-next-line no-param-reassign
    target.install = (0, plugin_1.createInstall)(install, target);
  }

  return target;
}

exports.default = default_1;